export function containsLocale(url) {
	const front = url.substr(0, 3);
	return front === '/en' || front === '/jp' || front === '/ar';
}

export function wrapTo(input, min, max) {
	const range = max - min;
	return (((input - min) % range) + range) % range + min;
}
